

























import { Component, Vue } from "vue-property-decorator";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import { CrudService } from "../../core/services/crudService";
import { Settings } from "../../core/services/configService";
import { CustomerHelper } from "../../crm/helpers/customerHelper";
import { ProgramPackTexts } from "../../bookings/programPackTexts";
import HomeCarouselFrame from "../home/HomeCarouselFrame.vue";
import ProgramProgress from "./ProgramProgress.vue";

const InProgress = 2;

@Component({
  components: { VueSlickCarousel, HomeCarouselFrame, ProgramProgress },
})
export default class ProgramsInProgress extends Vue {
  enrollments: any[] = [];
  texts = ProgramPackTexts;

  settings = {
    arrows: false,
    dots: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  t(key: string): string {
    return this.$t(key).toString();
  }

  doneText(e: any): string {
    return this.t("{0} of {1} appointments done")
      .replace("{0}", String(ProgramPackTexts.done(e)))
      .replace("{1}", String(ProgramPackTexts.sessions(e)));
  }

  async mounted() {
    const cid = CustomerHelper.getStoredCustomer();
    if (!cid) return;
    const data = await new CrudService().httpGet(`${Settings.HostName}/api/publicprogrampacks/customer/${cid}`);
    this.enrollments = data && data.ok ? data.data.filter((e: any) => e.status === InProgress) : [];
  }

  prev() {
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.prev) carousel.prev();
  }

  next() {
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.next) carousel.next();
  }
}
